export enum Follow {
  follow = 1,
  unfollow = 2,
}
